var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5004 1.91023C5.46275 1.91023 1.37892 5.99481 1.37892 11.0317C1.37892 16.0694 5.46275 20.1525 10.5004 20.1525C15.5381 20.1525 19.6212 16.0694 19.6212 11.0317C19.6212 5.99481 15.5377 1.91023 10.5004 1.91023ZM15.0951 9.19261C15.0999 9.29114 15.1017 9.39004 15.1017 9.49005C15.1017 12.5278 12.7896 16.0301 8.56166 16.0301C7.26372 16.0301 6.05505 15.6497 5.03789 14.9978C5.21791 15.0189 5.40053 15.0296 5.5861 15.0296C6.66327 15.0296 7.65451 14.6622 8.4409 14.0458C7.43522 14.0269 6.5866 13.362 6.29397 12.4489C6.43399 12.4763 6.57808 12.4901 6.72624 12.4901C6.9359 12.4901 7.13889 12.4626 7.33188 12.4097C6.27989 12.1985 5.48757 11.2688 5.48757 10.1561C5.48757 10.1461 5.48757 10.1364 5.48794 10.1264C5.79761 10.2987 6.1521 10.402 6.52918 10.4142C5.91207 10.0012 5.50646 9.29855 5.50646 8.50067C5.50646 8.07951 5.61981 7.68427 5.81761 7.34497C6.95146 8.73551 8.64537 9.65081 10.556 9.74638C10.5167 9.57858 10.4963 9.40263 10.4963 9.22261C10.4963 7.95357 11.5254 6.92418 12.7951 6.92418C13.4563 6.92418 14.0534 7.20347 14.4728 7.64983C14.9965 7.54722 15.4884 7.35534 15.9326 7.09198C15.7603 7.62908 15.3962 8.07951 14.9213 8.36362C15.3869 8.30805 15.83 8.18434 16.2419 8.00172C15.9344 8.46363 15.5444 8.86849 15.0951 9.19261Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f3cc772fed9d8b4df17cce5d30900987.svg";
export { ForwardRef as ReactComponent };